import { BaseHttpResponseError } from './base-http.error';

export class ItemAlreadyExistsError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}
